"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaMask = void 0;
const constant_1 = require("../../constant");
const eth_1 = require("../../eth");
const blockchain_1 = require("../../util/blockchain");
const ethers_1 = require("ethers");
const ethSignUtils = __importStar(require("eth-sig-util"));
const CONTRACT_HASH = {
    [blockchain_1.Blockchain.Ethereum]: {
        // use same rinkeby contract for all non-mainnet uses
        [constant_1.Network.TestNet]: '0xec8BC20687FfA944F57EB1aAa6F98FEDA30bcA65',
        [constant_1.Network.DevNet]: '0xec8BC20687FfA944F57EB1aAa6F98FEDA30bcA65',
        [constant_1.Network.LocalHost]: '0xec8BC20687FfA944F57EB1aAa6F98FEDA30bcA65',
        [constant_1.Network.MainNet]: '0xf4552877A40c1527D38970F170993660084D4541',
    },
    [blockchain_1.Blockchain.BinanceSmartChain]: {
        // use same testnet contract for all non-mainnet uses
        [constant_1.Network.TestNet]: '0x06E949ec2d6737ff57859CdcE426C5b5CA2Fc085',
        [constant_1.Network.DevNet]: '0x06E949ec2d6737ff57859CdcE426C5b5CA2Fc085',
        [constant_1.Network.LocalHost]: '0x06E949ec2d6737ff57859CdcE426C5b5CA2Fc085',
        [constant_1.Network.MainNet]: '0x3786d94AC6B15FE2eaC72c3CA78cB82578Fc66f4',
    },
};
const REGISTRY_CONTRACT_ABI = eth_1.ABIs.keyStorage;
const ENCRYPTION_VERSION = 'x25519-xsalsa20-poly1305';
const MNEMONIC_MATCH_REGEX = /-----BEGIN MNEMONIC PHRASE-----([a-z\s]*)-----END MNEMONIC PHRASE-----/mi;
const MNEMONIC_MATCH_REGEX_LEGACY = /^[a-z\s]*$/i;
const getEncryptMessage = (input) => {
    return `
  !!! Attention !!! Please make sure you are connecting to https://app.dem.exchange, do not confirm decrypt if you're connecting to untrusted sites.
  -----BEGIN MNEMONIC PHRASE-----
  ${input}
  -----END MNEMONIC PHRASE-----
  `.trim().replace(/^\s+/gm, '');
};
/**
 * TODO: Add docs
 */
class MetaMask {
    constructor(network) {
        this.network = network;
        this.blockchain = blockchain_1.Blockchain.Ethereum;
    }
    static getNetworkParams(network, blockchain = blockchain_1.Blockchain.Ethereum) {
        if (network === constant_1.Network.MainNet) {
            switch (blockchain) {
                case blockchain_1.Blockchain.BinanceSmartChain:
                    return {
                        chainId: '0x38',
                        blockExplorerUrls: ['https://bscscan.com'],
                        chainName: 'BSC Mainnet',
                        rpcUrls: [
                            'https://bsc-dataseed2.binance.org/',
                            'https://bsc-dataseed3.binance.org/',
                            'https://bsc-dataseed4.binance.org/',
                            'https://bsc-dataseed1.defibit.io/',
                            'https://bsc-dataseed2.defibit.io/',
                            'https://bsc-dataseed3.defibit.io/',
                            'https://bsc-dataseed4.defibit.io/',
                            'https://bsc-dataseed1.ninicoin.io/',
                            'https://bsc-dataseed2.ninicoin.io/',
                            'https://bsc-dataseed3.ninicoin.io/',
                            'https://bsc-dataseed4.ninicoin.io/',
                            'https://bsc-dataseed1.binance.org/',
                        ],
                        nativeCurrency: {
                            decimals: 18,
                            name: 'Binance Coin',
                            symbol: 'BNB',
                        },
                    };
                default:
                    // metamask should come with Ethereum configs
                    return { chainId: '0x1' };
            }
        }
        switch (blockchain) {
            case blockchain_1.Blockchain.BinanceSmartChain:
                return {
                    chainId: '0x61',
                    blockExplorerUrls: ['https://testnet.bscscan.com'],
                    chainName: 'BSC Testnet',
                    rpcUrls: [
                        'https://data-seed-prebsc-2-s1.binance.org:8545/',
                        'http://data-seed-prebsc-1-s2.binance.org:8545/',
                        'http://data-seed-prebsc-2-s2.binance.org:8545/',
                        'https://data-seed-prebsc-1-s3.binance.org:8545/',
                        'https://data-seed-prebsc-2-s3.binance.org:8545/',
                        'https://data-seed-prebsc-1-s1.binance.org:8545/',
                    ],
                    nativeCurrency: {
                        decimals: 18,
                        name: 'Binance Coin',
                        symbol: 'BNB',
                    },
                };
            default:
                // metamask should come with Ethereum configs
                return { chainId: '0x3' };
        }
    }
    static getRequiredChainId(network, blockchain = blockchain_1.Blockchain.Ethereum) {
        if (network === constant_1.Network.MainNet) {
            switch (blockchain) {
                case blockchain_1.Blockchain.BinanceSmartChain: return 56;
                default: return 1;
            }
        }
        switch (blockchain) {
            case blockchain_1.Blockchain.BinanceSmartChain: return 97;
            default: return 4;
        }
    }
    checkProvider(blockchain = this.blockchain) {
        const config = constant_1.NetworkConfigs[this.network];
        if (!config[blockchain]) {
            throw new Error(`MetaMask login not supported for this network ${this.network}`);
        }
        const ethNetworkConfig = config[blockchain];
        const provider = new ethers_1.ethers.providers.JsonRpcProvider(ethNetworkConfig.rpcURL);
        return provider;
    }
    getBlockchain() {
        return this.blockchain;
    }
    syncBlockchain() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const chainIdHex = yield ((_a = this.getAPI()) === null || _a === void 0 ? void 0 : _a.request({ method: 'eth_chainId' }));
            const chainId = !!chainIdHex ? parseInt(chainIdHex, 16) : undefined;
            const blockchain = (0, blockchain_1.getBlockchainFromChain)(chainId);
            this.blockchain = blockchain;
            return { chainId, blockchain };
        });
    }
    getSigner() {
        return __awaiter(this, void 0, void 0, function* () {
            const ethereum = yield this.getConnectedAPI();
            return new ethers_1.ethers.providers.Web3Provider(ethereum).getSigner();
        });
    }
    getAPI() {
        var _a;
        return (_a = window.ethereum) !== null && _a !== void 0 ? _a : null;
    }
    getConnectedAPI() {
        return __awaiter(this, void 0, void 0, function* () {
            const metamaskAPI = this.getAPI();
            if (!metamaskAPI) {
                throw new Error('MetaMask not connected, please check that your extension is enabled');
            }
            if (metamaskAPI === null || metamaskAPI === void 0 ? void 0 : metamaskAPI.isConnected()) {
                return metamaskAPI;
            }
            yield metamaskAPI.request({ method: 'eth_requestAccounts' });
            return metamaskAPI;
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getConnectedAPI();
        });
    }
    defaultAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            const metamaskAPI = yield this.getConnectedAPI();
            const [defaultAccount] = yield metamaskAPI.request({ method: 'eth_requestAccounts' });
            if (!defaultAccount) {
                throw new Error('No default account on MetaMask, please create one first');
            }
            return defaultAccount;
        });
    }
    getStoredMnemonicCipher(account, blockchain) {
        return __awaiter(this, void 0, void 0, function* () {
            const contractHash = this.getContractHash(blockchain);
            const provider = this.checkProvider(blockchain);
            const contract = new ethers_1.ethers.Contract(contractHash, REGISTRY_CONTRACT_ABI, provider);
            const cipherTextHex = yield contract.map(account);
            if (!(cipherTextHex === null || cipherTextHex === void 0 ? void 0 : cipherTextHex.length) || cipherTextHex === '0x') {
                // value would be '0x' if not initialized
                return undefined;
            }
            return cipherTextHex;
        });
    }
    encryptMnemonic(mnemonic) {
        return __awaiter(this, void 0, void 0, function* () {
            const metamaskAPI = yield this.getConnectedAPI();
            const defaultAccount = yield this.defaultAccount();
            const publicKey = yield metamaskAPI.request({
                method: 'eth_getEncryptionPublicKey',
                params: [defaultAccount],
            });
            const messageToEncrypt = getEncryptMessage(mnemonic);
            const cipher = ethSignUtils.encrypt(publicKey, {
                data: messageToEncrypt,
            }, ENCRYPTION_VERSION);
            const { version, nonce, ephemPublicKey, ciphertext, } = cipher;
            const encryptedMnemonic = ethers_1.ethers.utils.toUtf8Bytes([
                version,
                nonce,
                ephemPublicKey,
                ciphertext,
            ].join('.'));
            return Buffer.from(encryptedMnemonic).toString('hex');
        });
    }
    storeMnemonic(encryptedMnemonic, blockchain) {
        return __awaiter(this, void 0, void 0, function* () {
            const metamaskAPI = yield this.getConnectedAPI();
            const defaultAccount = yield this.defaultAccount();
            const storedMnemonicCipher = yield this.getStoredMnemonicCipher(defaultAccount, blockchain);
            if (storedMnemonicCipher) {
                throw new Error('Cannot store key on registry - key already exists for ETH account');
            }
            const contractHash = this.getContractHash(blockchain);
            const provider = this.checkProvider(blockchain);
            const contract = new ethers_1.ethers.Contract(contractHash, REGISTRY_CONTRACT_ABI, provider);
            const dataBytes = Buffer.from(encryptedMnemonic, 'hex');
            const unsignedTx = yield contract.populateTransaction.Store(dataBytes);
            const txHash = yield metamaskAPI.request({
                method: 'eth_sendTransaction',
                params: [Object.assign(Object.assign({}, unsignedTx), { from: defaultAccount })],
            });
            return txHash;
        });
    }
    login(blockchain) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const metamaskAPI = yield this.getConnectedAPI();
            const defaultAccount = yield this.defaultAccount();
            const cipherTextHex = yield this.getStoredMnemonicCipher(defaultAccount, blockchain);
            const chainIdHex = yield metamaskAPI.request({ method: 'eth_chainId' });
            const chainId = parseInt(chainIdHex, 16);
            const requiredChainId = this.getRequiredChain(this.network, chainId);
            if (chainId !== requiredChainId) {
                const requiredNetworkName = blockchain_1.ChainNames[requiredChainId] || blockchain_1.ChainNames[3];
                throw new Error(`MetaMask not connected to correct network, please use ${requiredNetworkName} (Chain ID: ${requiredChainId})`);
            }
            if (!cipherTextHex || !cipherTextHex.length) {
                return null;
            }
            const cipherText = ethers_1.ethers.utils.toUtf8String(cipherTextHex);
            const [version, nonce, ephemPublicKey, ciphertext] = cipherText.split('.');
            const cipher = {
                version,
                nonce,
                ephemPublicKey,
                ciphertext,
            };
            const decryptedCipherText = (_a = (yield metamaskAPI.request({
                method: 'eth_decrypt',
                params: [JSON.stringify(cipher), defaultAccount],
            }))) === null || _a === void 0 ? void 0 : _a.trim();
            // legacy encrypted mnemonic doesnt include warning message.
            if (decryptedCipherText.match(MNEMONIC_MATCH_REGEX_LEGACY)) {
                return decryptedCipherText;
            }
            // match line with prefix 'mnemonic: '
            const match = decryptedCipherText.match(MNEMONIC_MATCH_REGEX);
            // invalid cipher
            if (!match) {
                console.error('invalid account info retrieved from contract');
                console.error(decryptedCipherText);
                throw new Error('Retrieved invalid account on blockchain, please check console for more information.');
            }
            return (_b = match[1]) === null || _b === void 0 ? void 0 : _b.trim();
        });
    }
    getRequiredChain(network, currentChainId) {
        // set correct blockchain given the chain ID
        if (network === constant_1.Network.MainNet) {
            if (currentChainId === 1) {
                this.blockchain = blockchain_1.Blockchain.Ethereum;
                return currentChainId;
            }
            if (currentChainId === 56) {
                this.blockchain = blockchain_1.Blockchain.BinanceSmartChain;
                return currentChainId;
            }
            return 1;
        }
        if (currentChainId === 4) {
            this.blockchain = blockchain_1.Blockchain.Ethereum;
            return currentChainId;
        }
        if (currentChainId === 97) {
            this.blockchain = blockchain_1.Blockchain.BinanceSmartChain;
            return currentChainId;
        }
        // Deal with cases where users are logging in to devnet using mainnet chains
        if (currentChainId === 56) {
            return 97;
        }
        return 4;
    }
    getContractHash(blockchain = this.blockchain) {
        const contractHash = CONTRACT_HASH[blockchain][this.network];
        if (!contractHash) {
            throw new Error(`MetaMask login is not supported on ${this.network} on ${blockchain}`);
        }
        return contractHash;
    }
}
exports.MetaMask = MetaMask;
